import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    //   {
    //   path: '/',
    //   name: 'Intro',
    //   component: () => import('@/views/pages/intro/Intro.vue'),
    // }, 
    {
      path: '',
      name: 'Home',
      component: () => import('@/layouts/FullPage.vue'),
      children: [{
        path: '/',
        // path: '/main',
        name: 'Main',
        component: () => import('@/views/pages/web/main_v2/Main.vue'),
        // component: () => import('@/views/pages/web/Main.vue'),
        meta: {
          footer: true
        }
      }, {
        path: '/consulting/main',  /// 학부모 컨설팅 신청 랜딩 페이지
        name: 'ConsultingMain',
        component: () => import('@/views/pages/consulting/ConsultingMain.vue'),
        meta: {
          footer: false
        }
      }, {
        path: '/consulting/apply',  /// 학부모 컨설팅 신청(결제) 페이지
        name: 'ApplyConsulting',
        component: () => import('@/views/pages/consulting/ApplyConsulting.vue'),
        meta: {
          footer: false
        }
      }, {
        path: '/consulting/apply/privacy-policy',  /// 학부모 컨설팅 신청 개인정보 수집 동의
        name: 'ConsultingPrivacyPolicy',
        component: () => import('@/views/pages/consulting/PrivacyPolicy.vue'),
        meta: {
          footer: false
        }
      }, {
        path: '/consulting/apply/marketing-policy',  /// 학부모 컨설팅 신청 마케팅 활용 동의
        name: 'ConsultingMarketingPolicy',
        component: () => import('@/views/pages/consulting/MarketingPolicy.vue'),

        meta: {
          footer: false
        }
      }, {
        path: '/consulting/apply/done',  /// 학부모 컨설팅 신청 결제 완료
        name: 'ApplyConsultingDone',
        component: () => import('@/views/pages/consulting/ApplyDone.vue'),

        meta: {
          footer: false
        }
      }, {
        path: '/consulting/apply/failure',  /// 학부모 컨설팅 신청 결제 실패
        name: 'ApplyConsultingFailure',
        component: () => import('@/views/pages/consulting/ApplyFailure.vue'),

        meta: {
          footer: false
        }
      }, {
        path: '/mobile/main',
        name: 'MainMobile',
        component: () => import('@/views/pages/mobile/Main.vue'),
        meta: {
          footer: true
        }
      }, {
        path: '/test',
        name: 'Test',
        component: () => import('@/views/pages/web/TestPage.vue'),
      }, {
        path: '/mobile/payment',
        name: 'PaymentMain',
        component: () => import('@/views/pages/mobile/payment/ParentRanding3.vue'),
        meta: {
          footer: false
        }
      }, {
        path: '/terms-of-service',
        name: 'Terms',
        component: () => import('@/views/pages/web/Terms.vue'),
        meta: {
          footer: true
        }
      }, {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('@/views/pages/web/Privacy.vue'),
        meta: {
          footer: true
        }
      }, {
        path: 'parents/privacy',
        name: 'ParentsPrivacy',
        component: () => import('@/views/pages/web/PrivacyParents.vue'),
        meta: {
          footer: true
        }
      }, {
        path: '/mobile/privacy',
        name: 'PrivacyMobile',
        component: () => import('@/views/pages/mobile/Privacy.vue'),
        meta: {
          footer: true
        }
      },
      // {
      //   path: '/premium-service/guide',
      //   name: 'PremiumGuideWeb',
      //   component: () => import('@/views/pages/web/PremiumServiceGuide.vue'),
      // },
      {
        path: '/login',
        name: 'LoginWeb',
        component: () => import('@/views/pages/web/Login.vue'),
      }, {
        path: '/payment',
        name: 'PaymentWeb',
        component: () => import('@/views/pages/web/Payment.vue'),
      }, {
        path: '/payment/done',
        name: 'PaymentDone',
        component: () => import('@/views/pages/web/PaymentDone.vue'),
      }, {
        path: '/payment/proceed',
        name: 'PaymentProceed',
        component: () => import('@/views/pages/web/PaymentProceed.vue'),
      }, {
        path: '/payment/fail',
        name: 'PaymentFail',
        component: () => import('@/views/pages/web/PaymentFail.vue'),
      }, {
        path: '/admin/auth/login',
        name: 'AdminLogin',
        component: () => import('@/views/pages/web/auth/Login.vue'),
        meta: {
          hideHeader: true
        }
      }, {
        path: '/admin/sign-up',
        name: 'AdminSignIn',
        component: () => import('@/views/pages/web/auth/SignUp.vue'),
        meta: {
          hideHeader: true
        }
      }, {
        path: '/admin/sign-up-success',
        name: 'AdminSignInSuccess',
        component: () => import('@/views/pages/web/auth/SignUpSuccess.vue'),
        meta: {
          hideHeader: true
        }
      },
      ]
    }, {
      path: '',
      name: 'NavMain',
      component: () => import('@/layouts/components_v2/wrap/NavMainWithoutLeft.vue'),
      children: [{
        path: '/admin/admin-consulting',
        name: 'consulting',
        component: () => import('@/views/pages/web/admin-consulting/Main.vue'),
        meta: {
          pageTitle: 'AI 컨설팅',
          nameSearch: {
            'placeholder': '컨설팅'
          },
          goodsType: false,
          goodsState: false,
          registerState: false,
          createBtn: {
            'text': '등록',
            'style': 'fill',
            'icon': false
          },
          // customBtn: [
          //   {
          //     'text': '숨김 목록',
          //     'style': 'line',
          //     'action': () => {
          //       return '/admin/admin-product/hide'
          //     },
          //     'theme': 'gray'
          //   }
          // ],
          editMenu: false
        }
      }, {
        path: '/admin/admin-consulting/exam/analyze-info',
        name: 'consulting',
        component: () => import('@/views/pages/web/admin-consulting/consulting-exam/ConsultingExamAnalyzeInfoMain.vue'),
        meta: {
          pageTitle: 'AI 컨설팅 모의고사 분석정보',
          nameSearch: {
            'placeholder': '컨설팅 모의고사 분석정보'
          },
          goodsType: false,
          goodsState: false,
          registerState: false,
          createBtn: {
            'text': '등록',
            'style': 'fill',
            'icon': false
          },
          // customBtn: [
          //   {
          //     'text': '숨김 목록',
          //     'style': 'line',
          //     'action': () => {
          //       return '/admin/admin-product/hide'
          //     },
          //     'theme': 'gray'
          //   }
          // ],
          editMenu: false
        }
      }, {
        path: '/admin/app-payment/main',
        name: 'appPayment',
        component: () => import('@/views/pages/web/admin-app-payment/Main.vue'),
        meta: {
          pageTitle: 'e232',
          nameSearch: {
            'placeholder': '2323'
          },
          goodsType: false,
          goodsState: false,
          registerState: false,
          createBtn: {
            'text': '등록',
            'style': 'fill',
            'icon': false
          },
          editMenu: false
        }
      }, {
        path: '/exam/admin-question',
        name: 'Question',
        component: () => import('@/views/pages/web/admin-question/Main.vue'),
        meta: {
          pageTitle: '문제입력',
          year: true,
          subject: true,
          switch: true,
          userSearch: true,
          adminFilter: false,
          examType: true,
        }
      }, {
        path: '/admin/question-pool',
        name: 'QuestionPool',
        component: () => import('@/views/pages/web/admin-question-pool/Main.vue'),
        meta: {
          pageTitle: '문제풀 관리'
        }
      }, {
        path: '/admin/question-pool/shortage',
        name: 'QuestionPoolShortage',
        component: () => import('@/views/pages/web/admin/question-pool-shortage/Main.vue'),
        meta: {
          pageTitle: '문제 부족 현황'
        }
      }, {
        path: '/admin/question-pool/shortage/original',
        name: 'QuestionPoolShortageOriginal',
        redirect: { name: 'QuestionPoolShortageSchool' }
      }, {
        path: '/admin/question-pool/shortage/school',
        name: 'QuestionPoolShortageSchool',
        component: () => import('@/views/pages/web/admin/question-pool-shortage/Main.vue'),
        props: { summaryView: 'school' },
        meta: { pageTitle: '학교급별 요약 (모고 제외)' }
      }, {
        path: '/admin/question-pool/shortage/mock',
        name: 'QuestionPoolShortageMock',
        component: () => import('@/views/pages/web/admin/question-pool-shortage/Main.vue'),
        props: { summaryView: 'mock' },
        meta: { pageTitle: '모고별 요약' }
      }, {
        path: '/admin/ai-admin/error-reports',
        name: 'AiAdminErrorReports',
        component: () => import('@/views/pages/web/admin/ai-admin/ErrorReports.vue'),
        meta: { pageTitle: '일일 오류 보고서' }
      }, {
        path: '/admin/server-management/school-exams',
        name: 'ServerSchoolExamDashboard',
        component: () => import('@/views/pages/web/admin/server-management/SchoolExamDashboard.vue'),
        meta: { pageTitle: '학교 기출 관리', hideListFilter: true }
      }, {
        path: '/admin/server-management/schedulers',
        name: 'ServerSchedulerManagement',
        component: () => import('@/views/pages/web/admin/server-management/SchedulerManagement.vue'),
        meta: { pageTitle: '스케줄러 관리', hideListFilter: true }
      }, {
        path: '/admin/server-management/ssl',
        name: 'ServerSslManagement',
        component: () => import('@/views/pages/web/admin/server-management/SslManagement.vue'),
        meta: { pageTitle: 'SSL 관리', hideListFilter: true }
      }, {
        path: '/admin/ai-admin/codex-usage',
        name: 'AiAdminCodexUsage',
        component: () => import('@/views/pages/web/admin/ai-admin/CodexUsage.vue'),
        meta: {
          pageTitle: 'Codex 사용량'
        }
      }, {
        path: '/admin/management/question/concept-book-question',
        name: 'AdminConceptBookQuestionManage',
        component: () => import('@/views/pages/web/admin/management/question/concept-book-question/Main.vue'),
        meta: {
          pageTitle: '개념서 문제 생성',
          subject: false,
        }
      }, {
        path: '/admin/management/question/concept-book-question/:id',
        name: 'AdminConceptBookQuestionGenerate',
        component: () => import('@/views/pages/web/admin/management/question/concept-book-question/Generate.vue'),
        meta: {
          pageTitle: '개념서 문제 생성',
          subject: false,
        }
      }, {
        path: '/admin/management/question/variant-question',
        name: 'AdminVariantQuestionManageSummary',
        component: () => import('@/views/pages/web/admin/management/question/variant-question/Summary.vue'),
        meta: {
          pageTitle: '문제 기반 쌍둥이/변형 문제 생성',
          subject: false,
        }
      }, {
        path: '/admin/management/question/variant-question/list',
        name: 'AdminVariantQuestionManageList',
        component: () => import('@/views/pages/web/admin/management/question/variant-question/List.vue'),
        meta: {
          pageTitle: '문제 기반 쌍둥이/변형 문제 생성',
          subject: false,
        }
      }, {
        path: '/admin/question-pool/edit/:id?',
        name: 'QuestionPoolEdit',
        component: () => import('@/views/pages/web/admin-question-pool/QuestionEdit.vue'),
        meta: {
          pageTitle: '문제 편집'
        }
      }, {
        path: '/admin/management/review-monitoring/:uid?',
        name: 'AdminReviewMonitoring',
        component: () => import('@/views/pages/web/admin-review-monitoring/Main.vue'),
        meta: {
          pageTitle: '검토 모니터링'
        }
      }, {
        path: '/admin/management/copyright-exam-review',
        name: 'AdminCopyrightExamReview',
        component: () => import('@/views/pages/web/admin-copyright-exam-review/Main.vue'),
        meta: {
          pageTitle: '저작권 처리 시험 관리'
        }
      }, {
        path: '/admin/management/school-exam',
        name: 'AdminSchoolExamManage',
        component: () => import('@/views/pages/web/admin-school-exam/Main.vue'),
        meta: {
          pageTitle: '학교 시험지 관리'
        }
      }, {
        path: '/admin/management/settlement',
        name: 'AdminSettlement',
        component: () => import('@/views/pages/web/admin-settlement/Main.vue'),
        meta: {
          pageTitle: '정산 관리'
        }
      }, {
        path: '/admin/my-workspace/question-review',
        name: 'AdminQuestionReview',
        component: () => import('@/views/pages/web/admin/my-workspace/question-review/Main.vue'),
        meta: {
          pageTitle: '문제검토',
          // pageTitle: '문제검토 AI',
          year: true,
          subject: true,
          switch: true,
          userSearch: true,
          adminFilter: true,
          examType: true,
        }
      }, 
      {
        path: '/admin/my-workspace/question-review/v2',
        name: 'AdminQuestionReview_v2',
        component: () => import('@/views/pages/web/admin/my-workspace/question-review/v2/Main.vue'),
        meta: {
          pageTitle: '문제검토(신규)',
          // pageTitle: '문제검토 AI',
          year: true,
          subject: true,
          switch: true,
          userSearch: true,
          adminFilter: true,
          examType: true,
        }
      }, 
      {
        path: '/admin/my-workspace/text-convert-review',
        name: 'TextConversionReviewWork',
        component: () => import('@/views/pages/web/admin/my-workspace/text-convert-review/Main.vue'),
        meta: { pageTitle: '텍스트화 검수' }
      }, {
        path: '/admin/my-workspace/pml-work',
        name: 'PmlWork',
        redirect: to => ({ path: '/admin/management/question/text-convert/llm', query: to.query.question_id ? { question_id: to.query.question_id } : {} }),
      }, {
        path: '/admin/my-workspace/type-management',
        name: 'AdminTypeManagement',
        component: () => import('@/views/pages/web/admin/my-workspace/category-management/Main.vue'),
        meta: {
          pageTitle: '유형관리',
          year: true,
          subject: true,
          switch: true,
          userSearch: true,
          adminFilter: false,
          examType: true,
        }
      }, {
        path: '/admin/my-workspace/chapter-management',
        name: 'AdminChapterManagement',
        component: () => import('@/views/pages/web/admin/my-workspace/chapter-management/Main.vue'),
        meta: {
          pageTitle: '목차관리',
          year: true,
          subject: true,
          switch: true,
          userSearch: true,
          adminFilter: false,
          examType: true,
        }
      }, {
        path: '/admin/my-workspace/exam-review',
        name: 'AdminExamReview',
        component: () => import('@/views/pages/web/admin/my-workspace/exam-review/entered-exam/Main.vue'),
        meta: {
          pageTitle: '시험검토',
          year: true,
          subject: true,
          adminUser: true,
          switch: true,
          userSearch: true,
          nameSearch: {
            'placeholder': '시험 이름으로 검색'
          },
          adminFilter: true,
          examType: true,
        }
      }, {
        // pageType - 1: 전체 시험 관리, 2: 교과서 시험지 관리, 3: 학교 문제 관리
        path: '/admin/management/exam/:pageType',
        name: 'AdminManagementExam',
        component: () => import('@/views/pages/web/admin/management/exam/Main.vue'),
        meta: {
          pageTitleCustom: true,
          year: true,
          subject: true,
          nameSearch: {
            'placeholder': '시험 이름으로 검색',
            'placeholder1': '문제 id로 검색',
          },
          adminFilter: true,
          examType: true,
        }
      }, {
        path: '/admin/tools/exam-data-repair',
        name: 'AdminExamDataRepair',
        component: () => import('@/views/pages/web/admin/tools/ExamDataRepair.vue'),
        meta: { pageTitle: '기존 시험 데이터 보정', year: false, subject: false, adminFilter: false, examType: false },
      }, {
        path: '/admin/management/user-upload-exam',
        name: 'AdminUserUploadExam',
        component: () => import('@/views/pages/web/admin/management/user-upload-exam/Main.vue'),
        meta: {
          pageTitle: '학교 시험지 관리(학생)',
          year: false,
          subject: false,
          adminFilter: false,
          examType: false,
        }
      }, {
        path: '/admin/management/user-upload-exam/approved-batches',
        name: 'AdminApprovedUploadBatches',
        component: () => import('@/views/pages/web/admin/management/user-upload-exam/ApprovedBatches.vue'),
        meta: { pageTitle: '기존 승인 시험지 실행·사용량', hideListFilter: true, year: false, subject: false, adminFilter: false, examType: false },
      }, {
        path: '/admin/management/user-upload-exam/detail/:id',
        name: 'AdminUserUploadExamDetail',
        component: () => import('@/views/pages/web/admin/management/user-upload-exam/Detail.vue'),
        meta: {
          pageTitle: '',
          year: false,
          subject: false,
          adminFilter: false,
          examType: false,
        }
      }, {
        path: '/admin/my-workspace/error-exam',
        name: 'AdminErrorExam',
        component: () => import('@/views/pages/web/admin/my-workspace/exam-review/error-exam/Main.vue'),
        meta: {
          pageTitle: '오류있는 시험',
          nameSearch: {
            'placeholder': '시험 이름으로 검색'
          },
          subject: true,
          examType: true,
        }
      }, {
        path: '/exam/admin-question-bug-ai',
        name: 'Bug',
        component: () => import('@/views/pages/web/admin-question-bug-ai/Main.vue'),
        meta: {
          pageTitle: '신고된 시험 AI',
          nameSearch: {
            'placeholder': '시험 이름으로 검색'
          },
          subject: true,
          examType: true,
        }
      }, {
        path: '/admin/creation/mock-exam/:schoolType',
        name: 'AdminCreateMockExam',
        component: () => import('@/views/pages/web/admin/creation/mock-exam/Main.vue'),
        meta: {
          pageTitle: '시험생성(기출)',
          // pageTitle: '시험생성(기출 AI)',
          nameSearch: {
            'placeholder': '시험 이름으로 검색'
          },
          subject: true,
          createBtn: {
            'text': '시험 생성',
            'style': 'line',
            'icon': true
          },
        }
      }, {
        path: '/admin/creation/mock-exam/v2/:schoolType',
        name: 'AdminCreateMockExamV2',
        component: () => import('@/views/pages/web/admin/creation/mock-exam/v2/Main.vue'),
        meta: {
          pageTitle: '시험생성(기출)',
        }
      }, {
        path: '/admin/creation/mock-exam/v2/work/:schoolType',
        name: 'AdminCreateMockExamV2Work',
        component: () => import('@/views/pages/web/admin/creation/mock-exam/v2/Work.vue'),
        meta: {
          pageTitle: '시험생성(기출)',
        }
      }, {
        path: '/admin/creation/mock-variant',
        name: 'AdminMockVariant',
        component: () => import('@/views/pages/web/admin/creation/mock-variant/Main.vue'),
        meta: {
          pageTitle: '모의고사 전용 변형문제 생성',
        }
      }, {
        path: '/admin/creation/modified-mock-exam/:schoolType',
        name: 'AdminCreateModifiedMockExam',
        component: () => import('@/views/pages/web/admin/creation/modified-mock-exam/Main.vue'),
        meta: {
          pageTitle: '시험생성(기출변형)',
          year: true,
          nameSearch: {
            'placeholder': '시험 이름으로 검색(ex, 21년/수능/3월)'
          },
          subject: true
        }
      }, {
        path: '/admin/creation/ged-exam/:schoolType',
        name: 'AdminCreateGedExam',
        component: () => import('@/views/pages/web/admin/creation/ged-exam/Main.vue'),
        meta: {
          pageTitle: '시험생성(검정고시)',
          nameSearch: {
            'placeholder': '시험 이름으로 검색'
          },
          subject: true,
          createBtn: {
            'text': '시험 생성',
            'style': 'line',
            'icon': true
          },
        }
      }, {
        path: '/exam/admin-question-sample',
        name: 'Sample',
        component: () => import('@/views/pages/web/admin-question-sample/Main.vue'),
        meta: {
          pageTitle: '샘플 관리',
          subject: true,
        }
      }, {
        path: '/admin/management/admin-permission-settings',
        name: 'AdminPermissionSettings',
        component: () => import('@/views/pages/web/admin/management/admin-permission-settings/Main.vue'),
        meta: {
          pageTitle: '관리자 권한 설정',
          subject: false,
          userSearch: true,
        }
      }, {
        path: '/admin/admin-product',
        name: 'Product',
        component: () => import('@/views/pages/web/admin/product/admin-product/Main.vue'),
        meta: {
          pageTitle: '상품 관리 목록',
          nameSearch: {
            'placeholder': '상품명, 브랜드명으로 검색'
          },
          goodsType: true,
          goodsState: true,
          registerState: true,
          createBtn: {
            'text': '등록',
            'style': 'fill',
            'icon': false
          },
          customBtn: [
            {
              'text': '숨김 목록',
              'style': 'line',
              'action': () => {
                return '/admin/admin-product/hide'
              },
              'theme': 'gray'
            }
          ],
          editMenu: true
        }
      }, {
        path: '/admin/admin-product/hide',
        name: 'Product',
        component: () => import('@/views/pages/web/admin/product/admin-product/HideMain.vue'),
        meta: {
          pageTitle: '숨김 목록',
          goodsType: true,
          nameSearch: {
            'placeholder': '상품명, 브랜드명으로 검색'
          },
          customBtn: [
            {
              'text': '상품 목록',
              'style': 'line',
              'action': () => {
                return '/admin/admin-product'
              },
              'theme': 'gray'
            }, {
              'text': '복구',
              'style': 'fill',
              'action': () => {

              },
              'theme': 'primary'
            },
            {
              'text': '삭제',
              'style': 'line',
              'action': '',
              'theme': 'primary'
            },
          ]
        }
      }, {
        path: '/admin/admin-shiplist',
        name: 'Ship',
        component: () => import('@/views/pages/web/admin/product/ship/Main.vue'),
        meta: {
          pageTitle: '배송 관리 목록',
          editMenu: false,
          adminFilter: true,

        }
      }, {
        path: 'admin/admin-shiplist/item/order-id=:id',
        name: 'ItemPage',
        component: () => import('@/views/pages/web/admin/product/ship/ItemPage.vue'),
        props: true
      }, {
        path: '/admin/exam/management',
        name: 'ExamManagement',
        component: () => import('@/views/pages/web/admin-exam-management/Main.vue'),
        meta: {
          pageTitle: '시험 커스텀',
          subject: false
        }
      },
      {
        path: '/admin/custom/workbook',
        name: 'CustomWorkbook',
        component: () => import('@/views/pages/web/admin/custom/workbook/Main.vue'),
        meta: { keepAlive: true }
        // 문제집 커스텀
      },
      // { path: '/exam/admin-question-edit-staging',
      //   name: 'StagingEdit', component: () => import('@/views/pages/web/admin-exam-management/EditStagingExam.vue')
      // },
      {
        path: '/exam/admin-question-edit-staging',
        name: 'StagingEdit', component: () => import('@/views/pages/web/admin/custom/exam/ExamEdit.vue')
      },
      {  
        path: '/admin/custom/workbook/edit/:id?/question/admin-question-edit-staging',
        name: 'QuestionStagingEdit', component: () => import('@/views/pages/web/admin/custom/workbook/question/QuestionEdit.vue'),
        props: true,
      },
      {  
        path: '/admin/custom/workbook/edit/:id?/concept/admin-concept-edit-staging',
        name: 'ConceptStagingEdit', component: () => import('@/views/pages/web/admin/custom/workbook/concept/ConceptEdit.vue'),
        props: true,
      }
      ]
    }, {
      path: '',
      name: 'NavMain',
      component: () => import('@/layouts/components_v2/wrap/NavMainWithLeft.vue'),
      children: [{
        path: '/admin/creation/school-exam/:school',
        name: 'AdminCreateSchoolExam',
        component: () => import('@/views/pages/web/admin/creation/school-exam/Main.vue'),
        meta: {
          pageTitle: '시험생성(내신)',
          // pageTitle: '시험생성(내신) AI',
          year: true,
          subject: true,
          grade: true,
          semester: true,
          createBtn: {
            'text': '시험 생성',
            'style': 'line',
            'icon': true
          }
        }
      }, {
        path: '/admin/creation/school-exam-integrated',
        name: 'AdminCreateSchoolExamIntegrated',
        component: () => import('@/views/pages/web/admin/creation/school-exam-integrated/Main.vue'),
        meta: { pageTitle: '시험생성(내신 통합)' }
      }, {
        path: '/admin/creation/school-exam-new/:school',
        name: 'AdminCreateSchoolExamNew',
        component: () => import('@/views/pages/web/admin/creation/school-exam-new/Main.vue'),
        meta: {
          pageTitle: '시험생성(내신)',
          createBtn: {
            'text': '시험 생성',
            'style': 'line',
            'icon': true
          }
        }
      }, {
        path: '/admin/creation/textbook/:schoolType',
        name: 'AdminCreateTextbook',
        component: () => import('@/views/pages/web/admin/creation/textbook/Main.vue'),
        meta: {
          pageTitle: '시험생성(교재)',
          year: true,
        }
      },{
        path: '/admin/creation/textbook/v2/:schoolType',
        name: 'AdminCreateTextbook',
        component: () => import('@/views/pages/web/admin/creation/textbook/v2/Main.vue'),
        meta: {
          pageTitle: '시험생성(교재)',
          year: true,
          subject: true,
        }
      }
      ]
    },
    {
      path: '',
      name: 'NavMain_V2',
      component: () => import('@/layouts/components_v2/wrap/NavMainWithoutLeft_v2.vue'),
      children: [
        {
          path: '/admin/management/question/text-convert',
          name: 'QuestionTextConvert',
          component: () => import('@/views/pages/web/admin/management/question/text-convert/Index.vue')
        },
        {
          path: '/admin/question_check',
          name: 'QuestionCheck',
          component: () => import('@/views/pages/web/admin/question-check/Main.vue'),
          meta: {
            pageTitle: '문제 데이터 인사이트',
            hideHeader: false,
          }
        },
        {
          path: '/admin/management/question/text-convert/twin-variant',
          name: 'QuestionTextConvertTwinVariant',
          component: () => import('@/views/pages/web/admin/management/question/text-convert/twin-variant/Index.vue'),
          meta: {
            hideHeader: true,
          },
        },
        {
          path: '/admin/management/question/text-convert/twin-variant/result',
          name: 'QuestionTextConvertTwinVariantResult',
          component: () => import('@/views/pages/web/admin/management/question/text-convert/twin-variant/Result.vue'),
          meta: {
            hideHeader: true,
          },
        },
        {
          path: '/admin/ai-admin/prompt-test/variant',
          name: 'AiAdminPromptTestVariant',
          component: () => import('@/views/pages/web/admin/ai-admin/prompt-test/VariantPromptTest.vue'),
          meta: {
            hideHeader: true,
          },
        },
        {
          path: '/admin/ai-admin/prompt-test/essay-variant',
          name: 'AiAdminPromptTestEssayVariant',
          component: () => import('@/views/pages/web/admin/ai-admin/prompt-test/EssayVariantPromptTest.vue'),
          meta: {
            hideHeader: true,
          },
        },
        {
          path: '/admin/ai-admin/prompt-test/diagram',
          name: 'AiAdminPromptTestDiagram',
          component: () => import('@/views/pages/web/admin/ai-admin/prompt-test/DiagramPromptTest.vue'),
          meta: {
            hideHeader: true,
          },
        },
        {
          path: '/admin/ai-admin/prompt-test/concept-book',
          name: 'AiAdminPromptTestConceptBook',
          component: () => import('@/views/pages/web/admin/ai-admin/prompt-test/ConceptBookPromptTest.vue'),
          meta: {
            hideHeader: true,
          },
        },
        {
          path: '/admin/ai-admin/prompt-test/concept-book-image',
          name: 'AiAdminPromptTestConceptBookImage',
          component: () => import('@/views/pages/web/admin/ai-admin/prompt-test/ConceptBookImagePromptTest.vue'),
          meta: {
            hideHeader: true,
          },
        },
        {
          path: '/admin/ai-admin/prompt-test/concept-book-image-premised',
          name: 'AiAdminPromptTestConceptBookImagePremised',
          component: () => import('@/views/pages/web/admin/ai-admin/prompt-test/ConceptBookImagePremisedPromptTest.vue'),
          meta: {
            hideHeader: true,
          },
        }
      ]
    }, {
      path: '',
      name: 'ExamNavMain',
      component: () => import('@/layouts/ExamNavMain.vue'),
      children: [{
        path: '/admin/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/pages/web/admin/dashboard/Main.vue'),
        meta: {
          pageTitle: '대시보드'
        }
      }, {
        path: '/salary-detail',
        name: 'Calculate',
        component: () => import('@/views/pages/web/admin-pay/Main.vue'),
      },
      ]
    }, {
      path: '',
      name: 'UserNavMain',
      component: () => import('@/layouts/UserNavMain.vue'),
      children: [{
        path: '/admin/user-detail',
        name: 'UserDetail',
        component: () => import('@/views/pages/web/admin/user-list/DetailMain.vue'),
        meta: {
          pageTitle: '사용자 상세'
        }
      }, {
        path: '/admin/work-calendar',
        name: 'WorkCalendar',
        component: () => import('@/views/pages/web/admin/work-calendar/Main.vue'),
        meta: {
          pageTitle: '근무 달력'
        }
      }
      ]
    }, {
      path: '',
      name: 'ExamContent',
      component: () => import('@/layouts/ExamContent.vue'),
      children: [{
        path: '/exam/admin-exam-review/examReview',
        name: 'ExamReview',
        component: () => import('@/views/pages/web/admin-exam-review/ExamReview.vue'),
      }, {
        path: '/exam/admin-bug-edit',
        name: 'BugEdit',
        component: () => import('@/views/pages/web/admin-question-bug/ExamEdit.vue'),
      }, {
        path: '/exam/admin-bug-edit-ai',
        name: 'BugEdit',
        component: () => import('@/views/pages/web/admin-question-bug-ai/ExamEdit.vue'),
      }, {
        path: '/exam/admin-type-edit',
        name: 'TypeEdit',
        component: () => import('@/views/pages/web/admin-type/EditQuestion.vue'),
      }, {
        path: '/exam/admin-chapter-edit',
        name: 'ChapterEdit',
        component: () => import('@/views/pages/web/admin-chapter/EditQuestion.vue'),
      }, {
        path: '/exam/admin-question-edit',
        name: 'QuestionEdit',
        component: () => import('@/views/pages/web/admin-question/ExamEdit.vue'),
      }, {
        path: '/exam/admin-question-edit2',
        name: 'QuestionEdit2',
        component: () => import('@/views/pages/web/admin-question/ExamEdit_2.vue'),
      }, {
        path: '/exam/admin-question-edit-ai',
        name: 'QuestionEdit',
        component: () => import('@/views/pages/web/admin-question-ai/ExamEdit.vue'),
      }, {
        path: '/exam/admin-question-edit-ai/v2',
        name: 'QuestionEdit',
        component: () => import('@/views/pages/web/admin-question-ai/v2/ExamEdit.vue'),
      }, {
        path: '/exam/admin-old-hangul-works',
        name: 'OldHangulWorks',
        component: () => import('@/views/pages/web/admin-old-hangul-works/Index.vue'),
      },{
        path: '/exam/admin-question-sample/:state',
        name: 'QuestionSample',
        component: () => import('@/views/pages/web/admin-question/ExamSample.vue'),
      },
        // ,{
        //   path: '/exam/a',
        //   name: 'A',
        //   component: () => import('@/views/pages/web/admin-exam-review/a.vue')
        // }
      ]
    }, {
      path: '',
      name: 'GuideNavMain',
      component: () => import('@/layouts/GuideNavMain.vue'),
      children: [{
        path: '/guide',
        name: 'Guide',
        component: () => import('@/views/pages/web/exam-guide/Main.vue'),
      }
      ]
    }, {
      path: '/post',
      name: 'duam-post',
      component: () => import('@/views/pages/mobile/post.vue'),
    }, {
      path: '',
      name: 'Parents',
      component: () => import('@/layouts/FullPageParents.vue'),
      children: [{
        path: '/parents/intro',
        name: 'ParentsIntro',
        component: () => import('@/views/pages/parents/Main.vue'),
      }
      ]
    },
    // { 
    //   path: '/exam/admin-question-staging-info',
    //   name: 'StagingEdit', component: () => import('@/views/pages/web/admin-exam-management/QuestionInfo.vue')
    // },
    {
      path: '/admin/custom/question/view',
      name: 'QuestionView', //문제보기 새창
      component: () => import('@/views/pages/web/admin/custom/exam/QuestionView.vue'),
      meta: { layout: 'none' },
    },
    {
      path: '/admin/creation/concept-book/category',
      name: 'ConceptBookCategory',
      component: () => import('@/views/pages/web/admin/creation/concept-book/category/Main.vue'),
      meta: { keepAlive: true }
      // 유형별
    },
    {
      path: '/admin/creation/concept-book/content',
      name: 'ConceptBookContent',
      component: () => import('@/views/pages/web/admin/creation/concept-book/content/Main.vue'),
      meta: { keepAlive: true }
      // 목차별
    },
    {
      path: '/admin/creation/concept-book/literature',
      name: 'ConceptBookLiterature',
      component: () => import('@/views/pages/web/admin/creation/concept-book/literature/Main.vue'),
      meta: { keepAlive: true }
      // 작품별
    },
    {
      path: '/admin/custom/workbook/edit/:id?',
      name: 'CustomWorkbookEdit',
      component: () => import('@/views/pages/web/admin/custom/workbook/Edit.vue'),
      props: true,
      meta: { title: '문제집 편집' },
    },
    {
      path: '/admin/management/question/text-convert/edit/:mode?',
      name: 'QuestionTextConvertEdit',
      component: () => import('@/views/pages/web/admin/management/question/text-convert/edit/EditEntry.vue')
    },
    {
      path: '/admin/management/question/image-archive',
      name: 'QuestionImageArchive',
      component: () => import('@/views/pages/web/admin/management/question/image-archive/Index.vue'),
      meta: { title: '문제 이미지 아카이브' },
    },
    {
      path: '/admin/management/question/text-convert/llm',
      name: 'QuestionTextConvertLlm',
      component: () => import('@/views/pages/web/admin/management/question/text-convert/llm/Index.vue'),
    },
    {
      path: '/admin/management/question/text-convert/work',
      name: 'QuestionTextConvertWork',
      component: () => import('@/views/pages/web/admin/management/question/text-convert/work/Index.vue'),
      props: true
    },
    {
      path: '/admin/management/subject/textbook-content-map',
      name: 'TextbookContentMap',
      component: () => import('@/views/pages/web/admin/management/textbook-content-map/Index.vue'),
      meta: { title: '교재 목차-유형 매핑' },
    }
  ],
  scrollBehavior(to, from) {
    if (to.name === 'ServerSchoolExamDashboard' && from.name === to.name) return false
    return { x: 0, y: 0 }
  }
})

